import { TFunction } from 'i18next'
import { StringSchema } from 'yup'

import { nonEmptyStringSchema } from '@/Shared/ui/form'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const ibanSchema = (
  t: TFunction<'translation', undefined>,
  mustBeDiferent?: string,
): StringSchema<string> => {
  return (
    nonEmptyStringSchema(t)
      .transform(value => value.replace(/\s/g, ''))
      // Valida que el IBAN no sea igual a otro IBAN proporcionado (ej: cuenta origen ≠ cuenta destino)
      // Se comprueba antes del formato para mostrar el error más específico primero
      .test('must-be-diferent', t(formTranslation.errors.mustBeDiferent), value => {
        if (typeof value !== 'string') {
          return false
        }
        const normalizedMustBeDiferent = mustBeDiferent?.replace(/\s/g, '')
        return !normalizedMustBeDiferent || value !== normalizedMustBeDiferent
      })
      // Validación del dígito de control del IBAN (algoritmo MOD-97, norma ISO 13616)
      .test('must-comply-format', t(formTranslation.errors.invalidFormat), value => {
        if (typeof value !== 'string') {
          return false
        }

        const rearranged = value.slice(4) + value.slice(0, 4)

        const numericIBAN = rearranged
          .split('')
          .map(char => {
            const code = char.charCodeAt(0)
            return code >= 'A'.charCodeAt(0) && code <= 'Z'.charCodeAt(0)
              ? code - 'A'.charCodeAt(0) + 10
              : char
          })
          .join('')

        let remainder = numericIBAN
        let block

        while (remainder.length > 2) {
          block = remainder.slice(0, 9)
          remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length)
        }

        return parseInt(remainder, 10) % 97 === 1
      })
      .max(34, t(formTranslation.errors.maxChars, { value: 34 }))
      .matches(
        /^[A-Z]{2}[0-9]{2}[A-Z0-9]{0,34}$/,
        t(formTranslation.errors.invalidFormat),
      )
  )
}
